// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"98ceccb1","488":"b6dc6404","977":"a0c152dd"}[chunkId] + ".chunk.js";
};